import { Box } from '@chakra-ui/react'
import { LiveEventListItemFragment } from 'web-queries/src/types/generated'
import React from 'react'
import HeadingText from './HeadingText'
import LiveCalendar from './LiveCalendar'
import { liveListToEvents } from '../utils/calendar'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  visibleDate: Date
  lives: LiveEventListItemFragment[] | null
  onDateChange: (date: Date) => void
}
export default function LiveCalendarView({ visibleDate, lives, onDateChange }: Props) {
  const { t } = useTranslation('live')
  if (!lives) {
    return null
  }
  const events = liveListToEvents(lives)

  return (
    <Box>
      <>
        <HeadingText>{t('live-calendar')}</HeadingText>
        <LiveCalendar liveEvents={events} date={visibleDate} onNavigate={onDateChange} />
      </>
    </Box>
  )
}
